import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import {
    alertSessionStorageUsed,
    useAsyncSessionStorageData,
    getSessionStorageKey,
} from "@qgiv/core-donor";
// -------------------------------------------------------------------------
// NOTE: This component loads data that is set/cleared on registration submission.
// If DataDome intercepts the transaction, when the user is returned to the form
// all data is lost. When that happens, we can load the data from sessionStorage
// -------------------------------------------------------------------------

const UpdateEventDataFromSessionStorage = ({
    baseUrl,
    id,
    template,
    replaceRegistrationState,
    replaceRegistrationAccountState,
    replaceTeamsState,
    replaceExistingRegistrations,
    replaceParentRegistration,
    replaceRaceConditions,
    setPaymentPageValues,
}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const sessionStorageKey = getSessionStorageKey(id);
    const parsedFormDataObject = useAsyncSessionStorageData(sessionStorageKey);
    useEffect(
        () => {
            if (parsedFormDataObject) {
                // let BE know that we loaded form data from session storage
                alertSessionStorageUsed(id, template);
                // gather data to replace state with
                const newRegistration = parsedFormDataObject.registration;
                const newRegistrationAccount =
                    parsedFormDataObject.registrationAccount;
                const newTeams = parsedFormDataObject.teams;
                const newRaceConditions = parsedFormDataObject.raceConditions;
                const newExistingRegistrations =
                    parsedFormDataObject.existingRegistrations;
                const newParentRegistration =
                    parsedFormDataObject.parentRegistration;
                const paymentPageValues = parsedFormDataObject.values;

                // replace state and navigate to payment page
                setTimeout(() => {
                    dispatch(replaceRegistrationState(newRegistration));
                    dispatch(
                        replaceRegistrationAccountState(newRegistrationAccount),
                    );
                    dispatch(replaceTeamsState(newTeams));
                    dispatch(
                        replaceExistingRegistrations(newExistingRegistrations),
                    );
                    dispatch(replaceParentRegistration(newParentRegistration));
                    dispatch(replaceRaceConditions(newRaceConditions));
                    dispatch(setPaymentPageValues(paymentPageValues));
                    navigate(`${baseUrl}/form/payment`);
                }, 100);
            }
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [parsedFormDataObject],
    );

    return null;
};

UpdateEventDataFromSessionStorage.propTypes = {
    baseUrl: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
    template: PropTypes.number.isRequired,
    replaceRegistrationState: PropTypes.func.isRequired,
    replaceRegistrationAccountState: PropTypes.func.isRequired,
    replaceTeamsState: PropTypes.func.isRequired,
    replaceExistingRegistrations: PropTypes.func.isRequired,
    replaceParentRegistration: PropTypes.func.isRequired,
    replaceRaceConditions: PropTypes.func.isRequired,
    setPaymentPageValues: PropTypes.func.isRequired,
};

export default UpdateEventDataFromSessionStorage;
